__turbopack_context__.v({
  "cardHeader": "Tegel-module-scss-module__t4C2ha__cardHeader",
  "geleBanner": "Tegel-module-scss-module__t4C2ha__geleBanner",
  "iconTekst": "Tegel-module-scss-module__t4C2ha__iconTekst",
  "iconWrap": "Tegel-module-scss-module__t4C2ha__iconWrap",
  "isDisabled": "Tegel-module-scss-module__t4C2ha__isDisabled",
  "noListStyle": "Tegel-module-scss-module__t4C2ha__noListStyle",
  "notClickable": "Tegel-module-scss-module__t4C2ha__notClickable",
  "tegel": "Tegel-module-scss-module__t4C2ha__tegel",
  "tekstWrap": "Tegel-module-scss-module__t4C2ha__tekstWrap",
});
